
























































































































































































































































































































































































































































































































































































































































































































































































































































































































import { IAddToCartAction, ICartItem, IUpdateCartRequest } from '@/interfaces/cart'
import Vue, { VNode } from 'vue'
import { getCouponStatus, getWebAppCaps, setOrderInfo, getNuCoinInfo } from '@/api/checkout'
import { phoneAreaOptions, countryAreaOptions, countryISOCode, nationIndexToPhoneCode, phoneCodeToNationIndex } from '@/utils/data'
import DistrictInfo from '@/utils/districtInfo.json'
import moment from 'moment'
import { IOrderRequest } from '@/interfaces/checkout'
import { generateImagePath, checkNoMeshInProduct, checkNoMeshById } from '@/utils'
import * as Event from '@/utils/sendEvent'
import postAppMessage, { MessageHandlers } from '@/utils/poster'
import { IVariant } from '@/interfaces/product'
import QuantitySelector from '@/components/QuantitySelector.vue'
import { mapGetters, mapState } from 'vuex'
import { CartType } from '@/store/types'
import { MetaInfo } from 'vue-meta/types/vue-meta'
import { addValueOption } from '@/constants/checkout'

interface Option {
  text: string;
  value: string | number;
}

interface UserInfo {
  countryAreaSelected: string | null;
  countySelected: number | string | null;
  districtSelected: number | null;
  orderInfo: {
    email: string;
    name: string;
    phoneArea: string | null;
    phoneNumber: string;
  }
  shippingInfo: {
    address: string;
    name: string;
    phoneArea: string | null;
    phoneNumber: string;
    company: string;
    stateProvinceCity: string;
  },
  receiptNumber: string;
  paymentType: string;
}

interface Item {
  brand?: string;
  category?: string;
  id?: string;
  name?: string;
  price?: number | string;
  quantity?: number;
}

export default Vue.extend({
  name: 'Checkout',
  components: { QuantitySelector },
  data () {
    return {
      cartItemMinimumCollapseCount: 3,
      isShowingAllCartItems: false,
      receiptType: 'personal',
      receiptNumber: '',
      paymentMethod: 'card',
      paymentDescription: '',
      coinUse: true,
      nuCoinUse: true,
      coinDiscount: 0,
      nuCoinDiscount: 0,
      nuCoinObtain: 0,
      watchTime: 0,
      coinAdd: 0,
      addValueCost: 0,
      addValueTotal: 0,
      addValueSelected: 0, // index of optionShow
      couponCode: '',
      staticCouponCode: '',
      couponDiscount: 0,
      phoneAreaOptions: [{ text: '請選擇代碼', value: null, disabled: true }, ...phoneAreaOptions],
      countryAreaOptions: [{ text: '請選擇國家/地區', value: null, disabled: true }, ...countryAreaOptions],
      countryAreaSelected: null as string | null,
      countiesOptions: [{ text: '縣市', value: null, disabled: true }] as Array<any>,
      countySelected: null as string | number | null,
      districtOptions: [{ text: '鄉鎮市區', value: null, disabled: true }] as Array<any>,
      districtSelected: null as string | number | null,
      handlingFee: 0,
      orderInfo: {
        name: '',
        phoneArea: null as string | null,
        phoneNumber: '',
        email: ''
      },
      shippingInfo: {
        name: '',
        phoneArea: null as string | null,
        phoneNumber: '',
        address: '',
        company: '',
        stateProvinceCity: ''
      },
      shippingSelectVisibility: [true, true, false],
      shippingSelectDisabled: [true, true],
      checkoutConfig: {
        famiport_pay_off: 0,
        famiport_pay_fee: 25,
        no_famiport_pay_fee_off: 0,
        no_famiport_pay_fee_price: 499,
        no_deliver_fee_off: 0,
        foreign_deliver_fee: 150,
        deliver_fee_tw: 45,
        no_deliver_fee_price: 698,
        coupon_margin: 75,
        comp_resp_bank: 1,
        comp_resp_famiport: 1,
        comp_resp_credit: 1,
        cathay_credit_comp1: 0,
        cathay_credit_storeid: '',
        cathay_credit_cubkey: '',
        upload_image_server: '',
        ntd_to_usd: 27.74,
        hk_covid19_delivery: 0 // 1: show, 0: close
      },
      isEnableValidation: false,
      addressErrorMessage: '',
      hasError: false,
      isLoading: false,
      isShowToast: false,
      isCouponCodeValidating: false,
      isCheckoutProcessing: false,
      userCountryISOCode: '',
      isWaitingLoadUserInfoFromApp: false,
      updateCartApiQueueCount: 0,
      isAddValueCardOnly: false // 儲值開放轉帳及全家代碼的開關 （true: 僅支援信用卡）
    }
  },
  metaInfo (): MetaInfo {
    return {
      title: '結帳',
      titleTemplate: '%s | nuPhoto 拍立洗'
    }
  },
  computed: {
    ...mapState(['showNuCoin', 'showAddValue']),
    ...mapGetters({
      noDeliverFeePrice: 'noDeliverFeePrice',
      coinLeft: 'coinLeft',
      nuCoin: 'nuCoin',
      amount: 'cartAmount',
      additionalPurchasesList: 'buyMoreListOrder'
    }),
    cartList (): Array<ICartItem> {
      const tempCartList = this.$store.getters.cartList as Array<ICartItem>
      return tempCartList.filter(item => item.checked === 1)
    },
    couponUsed (): number {
      const costSum = this.$store.getters.cartAmount + this.handlingFee + this.getShippingFee
      if (costSum < this.couponDiscount - this.checkoutConfig.coupon_margin) {
        return 0
      }
      if (costSum < this.couponDiscount) {
        return costSum
      }
      return this.couponDiscount
    },
    coinUsedAmount () : number {
      const costSum = this.$store.getters.cartAmount + this.handlingFee + this.getShippingFee - this.couponUsed - this.nuCoinDiscount
      const neededCoinAmount = costSum
      // if (costSum < 3) {
      //   return 0
      // } else if (neededCoinAmount >= this.coinLeft) {
      if (neededCoinAmount >= this.coinLeft) {
        return this.coinLeft
      } else {
        return Math.floor(neededCoinAmount)
      }
    },
    nuCoinUsedAmount () : number {
      const costSum = this.$store.getters.cartAmount + this.handlingFee + this.getShippingFee - this.couponUsed
      const neededCoinAmount = Math.floor((costSum) * 100)
      // if (costSum < 3) {
      //   return 0
      // } else if (neededCoinAmount >= this.nuCoin) {
      if (neededCoinAmount >= this.nuCoin) {
        return Math.floor(this.nuCoin / 100) * 100
      } else {
        return neededCoinAmount
      }
    },
    getShippingFee (): number {
      let noMeshAll = true
      for (let itemIndex = 0; itemIndex < this.cartList.length; itemIndex += 1) {
        const tmpItem = this.cartList[itemIndex]
        if (!(this.noMesh(tmpItem))) {
          noMeshAll = false
          break
        }
      }
      if (noMeshAll) {
        return 0
      }
      if (this.countryAreaSelected === '台灣') {
        if (this.checkoutConfig.no_deliver_fee_off === 1) {
          return this.checkoutConfig.deliver_fee_tw
        } else if (this.checkoutConfig.no_deliver_fee_off === 0) {
          if (this.$store.getters.cartAmount >= this.checkoutConfig.no_deliver_fee_price) {
            return 0
          } else {
            return this.checkoutConfig.deliver_fee_tw
          }
        }
      } else if (this.countryAreaSelected === null) {
        return this.checkoutConfig.deliver_fee_tw
      }
      return this.checkoutConfig.foreign_deliver_fee
    },
    getFinalAmount (): number {
      const baseAmount = this.$store.getters.cartAmount
      const finalAmount = baseAmount + this.handlingFee - this.couponUsed - this.coinDiscount - this.nuCoinDiscount + this.getShippingFee
      if (finalAmount < 0) {
        return baseAmount + this.handlingFee - this.coinDiscount - this.nuCoinDiscount + this.getShippingFee
      }
      return finalAmount
    },
    addValueOptionShow (): Array<any> {
      // value 0 為不儲值選項
      // 其他低於show才顯示，如購物車金額>1800，則不顯示2000方案
      const filterArray = addValueOption.filter(item => {
        return item.value === 0 || item.show > this.$store.getters.cartAmount
      })
      // only show the least three cases larger than the cartAmount
      return filterArray.slice(0, 4)
    },
    addValueMode (): boolean {
      return this.addValueSelected > 0
    }
  },
  watch: {
    paymentMethod: function () {
      this.setHandlingFeeAndpaymentMethodDescription()
    },
    amount: function () {
      this.setHandlingFeeAndpaymentMethodDescription()
    },
    '$store.getters.cartList': function () {
      this.calculateCoinUsed()
    },
    async getFinalAmount () {
      this.watchTime = Date.now()
      if (this.getFinalAmount > 0 && !this.addValueMode) {
        await this.handleNuCoinObtain(this.watchTime)
      } else {
        this.nuCoinObtain = 0
      }
    },
    addValueSelected () {
      this.calculateCoinUsed(false)
      this.saveUserCheckoutConfigToLocalStorage()

      if (this.addValueMode && this.isAddValueCardOnly && this.paymentMethod !== 'card') {
        this.paymentMethod = 'card'
        this.saveUserInfoToLocalStorage()
        this.$bvModal.msgBoxOk('優惠儲值方案僅能使用信用卡付款。', {
          centered: true,
          footerClass: 'msgbox-ok-footer',
          okTitle: '確定'
        })
      }

      if (this.addValueMode && !this.isAddValueCardOnly && this.paymentMethod === 'famiPort' && this.addValueOptionShow[this.addValueSelected].value > 20000) {
        this.paymentMethod = 'card'
        this.saveUserInfoToLocalStorage()
        this.$bvModal.msgBoxOk('全家代碼繳費上限為20000元，已自動更改為信用卡付款。', {
          centered: true,
          footerClass: 'msgbox-ok-footer',
          okTitle: '確定'
        })
      }
    },
    addValueMode () {
      if (this.addValueMode) {
        this.coinUse = false
        this.nuCoinUse = false
      } else {
        this.coinUse = true
        this.nuCoinUse = this.showNuCoin
      }
    }
  },
  async created () {
    if (!this.showNuCoin) {
      this.nuCoinUse = false
    }
    if (!this.showAddValue) {
      this.addValueSelected = 0
      localStorage.setItem('eco/checkout', JSON.stringify({
        receiptType: this.receiptType,
        couponCode: this.couponCode,
        coinUse: this.coinUse,
        addValue: this.addValueSelected
      }))
    }
    window.getUserInfoFromApp = this.getUserInfoFromApp
    this.userCountryISOCode = this.$store.getters.country
    this.loadUserInfoFromLocalStorage()
    this.loadUserCheckoutConfigFromLocalStorage()
    this.calculateCoinUsed()
    this.updateCartApiQueueCount = 0

    if (!this.isWaitingLoadUserInfoFromApp) {
      this.loadDefaultValueIntoUserInfo()
    }

    // this.getCheckoutCartList() moved to get data before route
    if (this.$store.getters.webAppCaps) {
      this.checkoutConfig = this.$store.getters.webAppCaps
    } else {
      const { data } = await getWebAppCaps({ ver_no: this.$store.getters['webview/ver_no'] })
      this.checkoutConfig = data
    }
    Event.updateCurrencyRatio(this.checkoutConfig.ntd_to_usd)
    Event.initiatedCheckout(this.getFinalAmount)
    if (this.countryAreaSelected === '香港' && this.checkoutConfig.hk_covid19_delivery === 1) {
      this.showHkDeliveryMessage()
    }
  },
  methods: {
    async getCheckoutCartList () {
      this.isLoading = true

      try {
        // type = 1, get checkout cart list
        const data = await this.$store.dispatch('GET_CART_LIST', CartType.checkout)
        if (data.flag === 2) {
          // Token failed
          this.$bvModal.msgBoxOk('您已在其他地方登入，請重新登入。', {
            centered: true,
            footerClass: 'msgbox-ok-footer',
            okTitle: '確定'
          }).then(() => {
            if (this.$route.query.webview !== '1') {
              this.$router.push({ name: 'Login', query: { redirect: this.$route.path } })
            }
          })
        }
      } catch (error) {
        this.$bvModal.msgBoxOk(`發生錯誤，${error}`, {
          centered: true,
          footerClass: 'msgbox-ok-footer',
          okTitle: '確定'
        })
      } finally {
        this.isLoading = false
      }
    },
    loadDefaultValueIntoUserInfo () {
      // Set default value for iOS webview
      if (this.orderInfo.phoneArea === null) {
        this.orderInfo.phoneArea = '+886'
      }
      if (this.shippingInfo.phoneArea === null) {
        this.shippingInfo.phoneArea = '+886'
      }
      if (this.countryAreaSelected === null) {
        this.countryAreaSelected = '台灣'
        this.onCountryAreaChanged()
      }
    },
    onCopyOrdererInfo () {
      this.shippingInfo.name = this.orderInfo.name
      this.shippingInfo.phoneArea = this.orderInfo.phoneArea
      this.shippingInfo.phoneNumber = this.orderInfo.phoneNumber
      this.saveUserInfoToLocalStorage()
    },
    setAddressWithIndexes () {
      const addressIndexes = [this.countySelected, this.districtSelected]
      const company = this.shippingInfo.company
      this.onCountryAreaChanged()
      this.countySelected = addressIndexes[0]
      this.onCountyChanged()
      this.districtSelected = addressIndexes[1]
      this.onDistrictChanged()
      this.shippingInfo.company = company
    },
    onCountryAreaChanged () {
      let countryCode = ''
      if (this.countryAreaSelected === '台灣') {
        this.countiesOptions = [{ text: '縣市', value: null, disabled: true }, ...DistrictInfo.county_types]
        this.shippingSelectVisibility = [true, true, false]
        this.shippingSelectDisabled = [false, true]
        countryCode = 'TW'
      } else if (this.countryAreaSelected === '中國' || this.countryAreaSelected === '新加坡') {
        this.countiesOptions = []
        this.shippingSelectVisibility = [false, false, true]
        this.shippingSelectDisabled = [true, true]
        countryCode = 'CN'
      } else if (this.countryAreaSelected === '香港') {
        if (this.checkoutConfig.hk_covid19_delivery === 1) {
          this.showHkDeliveryMessage()
        }
        this.countiesOptions = [{ text: '區域', value: null, disabled: true }, ...DistrictInfo.county_types_HK]
        this.shippingSelectVisibility = [true, false, false]
        this.shippingSelectDisabled = [false, true]
        countryCode = 'HK'
      } else if (this.countryAreaSelected === '澳門') {
        this.countiesOptions = [{ text: '區域', value: null, disabled: true }, ...DistrictInfo.county_types_MC]
        this.shippingSelectVisibility = [true, false, false]
        this.shippingSelectDisabled = [false, true]
        countryCode = 'MO'
      }
      this.$store.commit('SET_COUNTRY', countryCode)
      this.countySelected = null
      this.districtSelected = null
      this.shippingInfo.company = ''
      this.onCountyChanged()
      this.calculateCoinUsed()
    },
    onCountyChanged () {
      if (this.countryAreaSelected === '台灣' && this.countySelected !== null) {
        const countyIndex = parseInt(this.countySelected.toString()) || 0
        this.districtOptions = [{ text: '鄉鎮市區', value: null, disabled: true }, ...DistrictInfo.district_types[countyIndex]]
        this.districtSelected = null
        this.shippingSelectDisabled = [false, false]
      }
      this.saveUserInfoToLocalStorage()
    },
    onDistrictChanged () {
      this.saveUserInfoToLocalStorage()
    },
    calculateCoinUsed (checkAddValueOption = true) {
      this.$nextTick(() => {
        this.nuCoinDiscount = this.nuCoinUse ? this.nuCoinUsedAmount / 100 : 0
        this.coinDiscount = this.coinUse ? this.coinUsedAmount : 0
        if (this.addValueMode) {
          if (checkAddValueOption) {
          // 價格更新後，儲值選項可能會變，檢查原本選的方案是否仍存在。若無，重設為不儲值
            const idx = this.addValueOptionShow.findIndex(item => item.value === this.addValueCost)
            this.addValueSelected = idx === -1 ? 0 : idx
          }
          this.calculateCoinAdded()
        } else {
          this.addValueCost = 0
          this.addValueTotal = 0
          this.coinAdd = 0
        }
      })
    },
    calculateCoinAdded () {
      this.addValueCost = this.addValueOptionShow[this.addValueSelected].value
      this.addValueTotal = this.addValueOptionShow[this.addValueSelected].total
      this.coinAdd = this.addValueTotal - this.getFinalAmount
    },
    onCoinUsedChanged () {
      this.saveUserCheckoutConfigToLocalStorage()
      this.calculateCoinUsed()
    },
    calculateCouponAvailable () {
      return this.couponDiscount <= this.$store.getters.cartAmount + this.handlingFee + this.getShippingFee + this.checkoutConfig.coupon_margin
    },
    onCouponCodeChanged () {
      if (this.couponCode.length === 0) {
        this.couponDiscount = 0
        this.calculateCoinUsed()
      }
    },
    async handleUseCouponCode (showModal: boolean) {
      this.$store.commit('logger/PUSH_LOG', 'handleUseCouponCode')
      if (this.couponCode.length === 0) {
        this.$store.commit('logger/PUSH_LOG', 'handleUseCouponCode: code is empty.')
        return
      }
      this.isLoading = true
      this.isCouponCodeValidating = true
      const version = this.$store.getters['webview/ver_no']
      try {
        const productStr = this.cartList.map((item) => item.variant_id).join(',')
        const response = await getCouponStatus({
          cpid: this.couponCode,
          ver_no: version,
          product: productStr,
          amount: this.$store.getters.cartAmount
        })

        if (response.data.flag === '0') {
          this.isLoading = false
          this.staticCouponCode = this.couponCode
          this.couponDiscount = parseInt(response.data.coupon_num)
          this.calculateCoinUsed()
          this.$store.commit('logger/PUSH_LOG', `${this.staticCouponCode} code use ${response.data.coupon_num}`)

          let displayText = response.data.msg
          if (!this.calculateCouponAvailable()) {
            const unused = this.couponDiscount - this.$store.getters.cartAmount - this.handlingFee - this.getShippingFee
            displayText = `本次消費最多可折抵 ${this.couponDiscount} 元，仍有 ${unused} 元未使用，請再消費 ${unused} 元才可完成交易。`
          }

          if (showModal) {
            this.$bvModal.msgBoxOk(`${displayText}`, {
              centered: true,
              footerClass: 'msgbox-ok-footer',
              okTitle: '確定'
            })
          }
          return Promise.resolve(true)
        } else {
          this.isLoading = false
          this.couponDiscount = 0
          this.calculateCoinUsed()

          this.$bvModal.msgBoxOk(`${response.data.msg}`, {
            centered: true,
            footerClass: 'msgbox-ok-footer',
            okTitle: '確定'
          })
          return Promise.resolve(false)
        }
      } catch (error) {
        this.isLoading = false
        this.couponDiscount = 0
        this.$bvModal.msgBoxOk('發生錯誤，請重新整理頁面後再試。', {
          centered: true,
          footerClass: 'msgbox-ok-footer',
          okTitle: '確定'
        })
        return Promise.reject(error)
      } finally {
        this.isCouponCodeValidating = false
      }
    },

    setHandlingFeeAndpaymentMethodDescription () {
      if (this.paymentMethod === 'famiPort') {
        const fee = this.checkoutConfig.famiport_pay_fee
        this.handlingFee = fee
        if (this.checkoutConfig.no_famiport_pay_fee_off === 1) {
          this.paymentDescription = `（全家代碼付款手續費 ${fee} 元）`
        } else if (this.checkoutConfig.no_famiport_pay_fee_off === 0) {
          if (this.$store.getters.cartAmount >= this.checkoutConfig.no_famiport_pay_fee_price) {
            this.handlingFee = 0
            this.paymentDescription = '（免手續費）'
          } else {
            this.paymentDescription = `（全家代碼付款手續費 ${fee} 元，滿 ${this.checkoutConfig.no_famiport_pay_fee_price} 元免手續費）`
          }
        }
      } else {
        this.handlingFee = 0
        this.paymentDescription = ''
      }
    },
    validateNotNullOrEmpty (target: string | number | null | undefined) {
      if (this.isEnableValidation) {
        if (target === null || target === undefined) {
          this.hasError = true
          return false
        }
        if (typeof (target) === 'string' && target.length === 0) {
          this.hasError = true
          return false
        }
        return true
      }
      return null
    },
    validatePhoneNumber (phoneNumberCode: string | null, phoneNumber: string): boolean | null {
      if (!this.isEnableValidation) return null
      if (!phoneNumber.match(/^\d+$/)) {
        this.hasError = true
        return false
      }
      let result = null
      switch (phoneNumberCode) {
        case '+886':
          result = (phoneNumber.length === 10 && /^09/.test(phoneNumber))
          break
        case '+86':
          result = phoneNumber.length === 11
          break
        case '+852':
        case '+853':
        case '+65':
          result = phoneNumber.length === 8
          break
        default:
          result = false
      }
      if (result === false) {
        this.hasError = true
        return false
      } else return result
    },
    validateEmail (email: string) {
      if (!this.isEnableValidation) return null
      const emailRegex = /^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/
      const result = emailRegex.test(email)
      if (result) return result
      this.hasError = true
      return false
    },
    validateState () {
      if (!this.isEnableValidation) return null
      if (this.countryAreaSelected === '中國' || this.countryAreaSelected === '新加坡') {
        if (this.shippingInfo.stateProvinceCity.length === 0) {
          this.hasError = true
          return false
        }
      }
      return true
    },
    validateCounty () {
      if (!this.isEnableValidation) return null
      if (this.countryAreaSelected === null) return false
      if (this.countryAreaSelected === '中國' || this.countryAreaSelected === '新加坡') return true
      if (this.countySelected !== null) return true
      this.hasError = true
      return false
    },
    validateDistrict () {
      if (!this.isEnableValidation) return null
      if (this.countryAreaSelected !== '台灣') return true
      if (this.districtSelected !== null) return true
      this.hasError = true
      return false
    },
    validateAddress () {
      if (!this.isEnableValidation) return null
      if (this.countryAreaSelected === '台灣') {
        if (this.shippingInfo.address.length < 5) {
          this.addressErrorMessage = '請填入正確的詳細地址'
          this.hasError = true
          return false
        }

        const keywords = {
          全家: ['全家福'],
          門市: [] as Array<string>,
          超商: [] as Array<string>,
          小七: [] as Array<string>,
          '7-11': [] as Array<string>
        }
        let flag = false
        for (const [key, value] of Object.entries(keywords)) {
          flag = this.shippingInfo.address.includes(key)
          if (flag) {
            if (value.length > 0) {
              for (const excludeKey of value) {
                if (this.shippingInfo.address.includes(excludeKey)) {
                  flag = false
                  break
                }
              }
            }
          }
          if (flag) {
            break
          }
        }
        // find keywords
        if (flag) {
          this.addressErrorMessage = '不支援超商取貨，若填寫超商地址，將無法寄達，請留下有人可以簽收的地址。'
          this.hasError = true
        }
        return !flag
      } else if (this.countryAreaSelected === '中國') {
        if (this.shippingInfo.address.length < 4 || this.shippingInfo.company.length < 4) {
          this.addressErrorMessage = '因中國海關要求, 印刷品僅能寄送至公司行號, 請務必提供4個字以上的公司名稱及地址。'
          this.hasError = true
          return false
        }
        return true
      } else {
        if (this.shippingInfo.address.length < 6) {
          this.addressErrorMessage = '請填入正確的詳細地址'
          this.hasError = true
          return false
        } else {
          return true
        }
      }
    },
    validateCompany () {
      if (!this.isEnableValidation) return null

      if (this.countryAreaSelected === '中國') {
        if (this.shippingInfo.address.length < 4 || this.shippingInfo.company.length < 4) {
          this.addressErrorMessage = '因中國海關要求, 印刷品僅能寄送至公司行號, 請務必提供4個字以上的公司名稱及地址。'
          this.hasError = true
          return false
        }
        return true
      }
      return true
    },
    validateReceipt () {
      if (this.receiptType !== 'company' || !this.isEnableValidation) return null
      if (this.receiptNumber.length !== 8) {
        this.hasError = true
        return false
      }
      // Reference: https://www.fia.gov.tw/singlehtml/3?cntId=c4d9cff38c8642ef8872774ee9987283

      const weight = [1, 2, 1, 2, 1, 2, 4, 1]
      const GUIsum = this.receiptNumber.split('').map((item, index) => {
        return parseInt(item) * weight[index] // Multipy by weight each
      }).map((item) => {
        return (item / 10 >> 0) + item % 10 // Sum of tens and units digit
      }).reduce((sum, cur) => {
        return sum + cur // Sum of all
      })

      return this.receiptNumber[6] === '7' // Check if divisible by 5
        ? GUIsum % 5 === 0 || (GUIsum + 1) % 5 === 0
        : GUIsum % 5 === 0

      /*
      const code = [1, 2, 1, 2, 1, 2, 4, 1]
      let sum = 0
      for (let i = 0; i < 8; i++) {
        let tmp = parseInt(this.receiptNumber.charAt(i)) * code[i]
        if (tmp >= 10) {
          tmp = (tmp % 10) + (tmp - (tmp % 10)) / 10
        }
        sum += tmp
      }
      if (sum % 10 === 0) {
        return true
      } else {
        if (parseInt(this.receiptNumber.charAt(6)) === 7 && ((sum + 1) % 10) === 0) {
          return true
        } else {
          this.hasError = true
          return false
        }
      }
      */
    },
    onCheckoutClicked () {
      this.isCheckoutProcessing = true
      this.saveUserInfoToLocalStorage()
      this.isEnableValidation = true

      // Invoke in next tick to wait for isEnableValidation change and all input states change
      this.$nextTick(async () => {
        let validationOverall = true // The result of all validations clear
        const orderInfo = this.orderInfo
        const shippingInfo = this.shippingInfo
        const errorStack = []

        // Validate order information
        if (!(this.validateNotNullOrEmpty(orderInfo.name) &&
        this.validateNotNullOrEmpty(orderInfo.phoneArea) &&
        this.validatePhoneNumber(orderInfo.phoneArea, orderInfo.phoneNumber) && this.validateEmail(orderInfo.email))) {
          errorStack.push('訂購人資訊欄位填寫錯誤。')
          validationOverall = false
        }

        // Validate shippong information
        if (!(
          this.validateNotNullOrEmpty(shippingInfo.name) &&
          this.validateNotNullOrEmpty(shippingInfo.phoneArea) &&
          this.validatePhoneNumber(shippingInfo.phoneArea, shippingInfo.phoneNumber)
        )) {
          errorStack.push('收件人人資訊欄位填寫錯誤。')
          validationOverall = false
        }

        if (!(
          this.validateNotNullOrEmpty(this.countryAreaSelected) &&
          this.validateState() &&
          this.validateCounty() &&
          this.validateDistrict() &&
          this.validateAddress() &&
          this.validateCompany())) {
          errorStack.push('收件人人地址欄位填寫錯誤。')
          validationOverall = false
        }

        // Validate company receipt information when its type is 'company'
        if (this.receiptType === 'company' && !this.validateReceipt()) {
          errorStack.push('公司統一編號輸入錯誤。')
          validationOverall = false
        }

        // Collect error messages and show them once
        const messageVNode = []
        for (const e of errorStack) {
          messageVNode.push(this.$createElement('p', { class: ['text-center', 'mt-2', 'mb-0'] }, e))
        }

        // Show the message if validation failed then return
        if (validationOverall === false) {
          this.isCheckoutProcessing = false
          this.$bvModal.msgBoxOk(messageVNode, {
            centered: true,
            footerClass: 'msgbox-ok-footer',
            okTitle: '確定'
          })
          return
        }

        // Pass validations
        // Check if coupon code field is not empty, call api with no showing modal.
        try {
          if (this.couponCode.length > 0) {
            const result = await this.handleUseCouponCode(false)
            if (!result) {
              this.isCheckoutProcessing = false

              this.$store.commit('logger/PUSH_LOG', { checkoutError: false, on: 'handleUseCouponCode' })
              return
            }
          } else {
            this.staticCouponCode = this.couponCode
            this.couponDiscount = 0
            this.calculateCoinUsed()
          }
        } catch (error) {
          this.isCheckoutProcessing = false
          this.$store.commit('logger/PUSH_LOG', { checkoutError: error, on: 'handleUseCouponCode' })
          console.error(error)
          return
        }

        const orderId = this.gernerateOrderId()
        this.$store.commit('logger/PUSH_LOG', { orderId })
        if (orderId === undefined) {
          this.isCheckoutProcessing = false
          throw new Error('訂單號碼錯誤')
        }
        const orderData = {
          orderId,
          amount: this.getFinalAmount,
          shipping: this.getShippingFee
        }
        this.$store.commit('order/SET_ORDER', orderData)
        this.$store.commit('logger/PUSH_LOG', { orderData })
        this.$store.commit('logger/PUSH_LOG', `paymentMethod: ${this.paymentMethod}`)

        this.handleSetOrderInfo(orderId)
      })
    },
    sendTracingData (orderId: string) {
      // Google Analytics
      const gTagCartItems = [] as Array<any>
      // Facebook Pixel
      const facebookCartItems = [] as Array<any>
      // const amount = this.getFinalAmount < 3 ? 0 : this.getFinalAmount
      const amount = this.getFinalAmount

      this.cartList.forEach(item => {
        gTagCartItems.push({
          id: item.variant_id.toString(),
          name: item.product_title,
          variant: item.title,
          quantity: item.qty,
          currency: 'TWD',
          price: item.price_text.replace(/\D/g, '')
        })

        facebookCartItems.push({
          id: item.variant_id.toString(),
          quantity: item.qty
        })
      })

      this.$gtag.purchase({
        transaction_id: orderId,
        affiliation: 'nuPhoto 電商網站',
        value: amount,
        currency: 'TWD',
        tax: 0,
        shipping: this.getShippingFee,
        items: gTagCartItems
      } as any)

      Event.purchase(orderId, amount, facebookCartItems)
      this.$store.commit('logger/PUSH_LOG', { orderId, value: amount / 33 })
    },
    getUserInfoFromApp (message: string) {
      if (message) {
        try {
          const parsedData = this.tranformUserInfoFromAppToWeb(JSON.parse(message)) as UserInfo
          this.assignUserInfoFromData(parsedData)
          this.setAddressWithIndexes()
        } catch (error) {
          console.error(error)
        }
      }
      this.isWaitingLoadUserInfoFromApp = false
      this.loadDefaultValueIntoUserInfo()
      localStorage.setItem('eco/loadedFromApp', JSON.stringify(true))
    },
    loadUserInfoFromApp () {
      postAppMessage(MessageHandlers.LOAD_USER_INFO, 'loadUserInfoFromApp')
    },
    saveUserInfoToLocalStorage () {
      const userInfo = this.getUserInfoObject()
      for (const [key, value] of Object.entries(userInfo)) {
        if (value == null) continue
        localStorage.setItem(key, value.toString())
      }

      postAppMessage(MessageHandlers.SAVE_USER_INFO, userInfo)
      localStorage.setItem('eco/loadedFromApp', JSON.stringify(true))
    },
    getUserInfoObject () {
      let paymentType
      if (this.paymentMethod === 'card') {
        paymentType = 0
      } else if (this.paymentMethod === 'transfer') {
        paymentType = 1
      } else if (this.paymentMethod === 'famiPort') {
        paymentType = 2
      }
      return {
        userName: this.orderInfo.name,
        userCountry: this.orderInfo.phoneArea ? phoneCodeToNationIndex[this.orderInfo.phoneArea] : null,
        userPhone: this.orderInfo.phoneNumber,
        userEmail: this.orderInfo.email,
        receiverName: this.shippingInfo.name,
        receiverCountry: this.shippingInfo.phoneArea ? phoneCodeToNationIndex[this.shippingInfo.phoneArea] : null,
        receiverPhone: this.shippingInfo.phoneNumber,
        receiverNation: countryAreaOptions.findIndex(country => country === this.countryAreaSelected),
        receiverCounty: this.countryAreaSelected === '台灣' ? this.countySelected : null,
        receiverCountyHK: this.countryAreaSelected === '香港' ? this.countySelected : null,
        receiverCountyMC: this.countryAreaSelected === '澳門' ? this.countySelected : null,
        receiverDistrict: this.countryAreaSelected === '台灣' ? this.districtSelected : null,
        receiverStreet: this.countryAreaSelected === '台灣' ? this.shippingInfo.address : null,
        receiverGlobal1: this.countryAreaSelected === '中國' || this.countryAreaSelected === '新加坡' ? this.shippingInfo.stateProvinceCity : null,
        receiverGlobal2: this.countryAreaSelected !== '台灣' ? this.shippingInfo.address : null,
        receiverCompany: this.countryAreaSelected === '中國' ? this.shippingInfo.company : null,
        receiptNum: this.receiptNumber,
        paymentType: paymentType
      }
    },
    loadUserInfoFromLocalStorage () {
      const orderInfoName = localStorage.getItem('userName') || '' // 使用者姓名
      const orderUserCountry = localStorage.getItem('userCountry')
      let orderInfoPhoneArea = null // 使用者電話國家 (0: "台灣", 1: "中國", 2: "香港", 3: "澳門", 4: "新加坡")
      if (orderUserCountry !== null) {
        orderInfoPhoneArea = nationIndexToPhoneCode[orderUserCountry]
        if (orderInfoPhoneArea === undefined) { orderInfoPhoneArea = null }
      }

      const orderInfoPhoneNumber = localStorage.getItem('userPhone') || '' // 使用者電話號碼
      const orderInfoEmail = localStorage.getItem('userEmail') || '' // 使用者email

      const orderInfo = {
        name: orderInfoName,
        phoneArea: orderInfoPhoneArea,
        phoneNumber: orderInfoPhoneNumber,
        email: orderInfoEmail
      }

      const shippingInfoName = localStorage.getItem('receiverName') || '' // 收件人姓名
      const shippingInfoCountry = localStorage.getItem('userCountry')
      let shippingInfoPhoneArea = null // 收件人電話國家 (0: "台灣", 1: "中國", 2: "香港", 3: "澳門", 4: "新加坡")
      if (shippingInfoCountry !== null) {
        shippingInfoPhoneArea = nationIndexToPhoneCode[shippingInfoCountry]
      }
      const shippingInfoPhoneNumber = localStorage.getItem('receiverPhone') || '' // 收件人電話號碼
      const nationString = localStorage.getItem('receiverNation') // 收件人地址國家
      let countryAreaSelected
      if (nationString == null) {
        countryAreaSelected = null
      } else {
        const nationIndex = parseInt(nationString)
        if (isNaN(nationIndex)) {
          countryAreaSelected = null
        } else {
          countryAreaSelected = countryAreaOptions[nationIndex]
        }
      }

      let countySelected = null
      let districtSelected = null
      let address = ''
      let stateProvinceCity = ''
      let company = ''
      if (countryAreaSelected === '台灣') {
        // NaN || null = null
        const countryString = localStorage.getItem('receiverCounty') // 收件人縣市index (臺灣專用)
        if (countryString) {
          countySelected = parseInt(countryString)
        }
        const districtString = localStorage.getItem('receiverDistrict') // 收件人縣市index (臺灣專用)
        if (districtString) {
          districtSelected = parseInt(districtString)
        }
        address = localStorage.getItem('receiverStreet') || '' // 收件人詳細地址 (臺灣專用)
      } else if (countryAreaSelected === '香港') {
        countySelected = localStorage.getItem('receiverCountyHK') || null // 收件人行政區名稱 (香港專用)
        address = localStorage.getItem('receiverGlobal2') || '' // 收件人詳細地址 (臺灣以外國家專用)
      } else if (countryAreaSelected === '澳門') {
        countySelected = localStorage.getItem('receiverCountyMC') || null // 收件人行政區名稱 (澳門專用)
        address = localStorage.getItem('receiverGlobal2') || '' // 收件人詳細地址 (臺灣以外國家專用)
      } else if (countryAreaSelected === '中國') {
        stateProvinceCity = localStorage.getItem('receiverGlobal1') || '' // 收件人郵編州省城市 (中國/新加坡專用)
        address = localStorage.getItem('receiverGlobal2') || '' // 收件人詳細地址 (臺灣以外國家專用)
        company = localStorage.getItem('receiverCompany') || '' // 收件人公司 (中國專用)
      } else if (countryAreaSelected === '新加坡') {
        stateProvinceCity = localStorage.getItem('receiverGlobal1') || '' // 收件人郵編州省城市 (中國/新加坡專用)
        address = localStorage.getItem('receiverGlobal2') || '' // 收件人詳細地址 (臺灣以外國家專用)
      } else {
        countryAreaSelected = null
      }

      const shippingInfo = {
        name: shippingInfoName,
        phoneArea: shippingInfoPhoneArea,
        phoneNumber: shippingInfoPhoneNumber,
        address,
        stateProvinceCity,
        company
      }

      const receiptNumber = localStorage.getItem('receiptNum') || '' // 發票統編
      const paymentType = localStorage.getItem('paymentType') || '' // 付款方式index (0: 信用卡, 1: 銀行轉帳, 2: 全家付款)

      const data = {
        countryAreaSelected,
        countySelected,
        districtSelected,
        orderInfo,
        shippingInfo,
        receiptNumber,
        paymentType
      }

      if (this.$store.getters.isWebViewMode) {
        this.assignUserInfoFromData(data)
        if (this.isDefaultUserInfo(data)) {
          this.isWaitingLoadUserInfoFromApp = true
          this.loadUserInfoFromApp()
        } else {
          this.setAddressWithIndexes()
        }
      } else {
        if (!this.isDefaultUserInfo(data)) {
          this.assignUserInfoFromData(data)
          this.setAddressWithIndexes()
        }
      }
    },
    loadUserCheckoutConfigFromLocalStorage () {
      const dataString = localStorage.getItem('eco/checkout')
      if (dataString) {
        const data = JSON.parse(dataString)
        if (data) {
          this.receiptType = data.receiptType
          this.couponCode = data.couponCode
          if (data.coinUse) { this.coinUse = this.coinLeft > 0 ? data.coinUse : false }
          setTimeout(() => {
            this.addValueSelected = data.addValue
          }, 250) // not worked if no delay set
        }
      }
    },
    saveUserCheckoutConfigToLocalStorage () {
      this.saveUserInfoToLocalStorage()
      localStorage.setItem('eco/checkout', JSON.stringify({
        receiptType: this.receiptType,
        couponCode: this.couponCode,
        coinUse: this.coinUse,
        addValue: this.addValueSelected
      }))
    },
    clearCheckoutConfig () {
      localStorage.removeItem('eco/checkout')
    },
    tranformUserInfoFromAppToWeb (data: any) {
      if (data) {
        const orderUserCountry = data.userCountry
        let orderInfoPhoneArea = null // 使用者電話國家 (0: "台灣", 1: "中國", 2: "香港", 3: "澳門", 4: "新加坡")
        if (orderUserCountry !== null) {
          orderInfoPhoneArea = nationIndexToPhoneCode[orderUserCountry]
          if (orderInfoPhoneArea === undefined) { orderInfoPhoneArea = null }
        }

        const orderInfo = {
          name: data.userName,
          phoneArea: orderInfoPhoneArea,
          phoneNumber: data.userPhone,
          email: data.userEmail
        }

        const shippingInfoName = data.receiverName
        const shippingInfoCountry = data.userCountry
        let shippingInfoPhoneArea = null // 收件人電話國家 (0: "台灣", 1: "中國", 2: "香港", 3: "澳門", 4: "新加坡")
        if (shippingInfoCountry !== null) {
          shippingInfoPhoneArea = nationIndexToPhoneCode[shippingInfoCountry]
        }
        const shippingInfoPhoneNumber = data.receiverPhone
        const nationString = data.receiverNation
        let countryAreaSelected
        if (nationString == null) {
          countryAreaSelected = null
        } else {
          const nationIndex = parseInt(nationString)
          if (isNaN(nationIndex)) {
            countryAreaSelected = null
          } else {
            countryAreaSelected = countryAreaOptions[nationIndex]
          }
        }

        let countySelected = null
        let districtSelected = null
        let address = ''
        let stateProvinceCity = ''
        let company = ''
        if (countryAreaSelected === '台灣') {
        // NaN || null = null
          const countryString = data.receiverCounty
          // Be care of 0 == false, null == false
          if (countryString !== null && countryString !== undefined) {
            countySelected = parseInt(countryString)
          }
          const districtString = data.receiverDistrict // 收件人縣市index (臺灣專用)
          if (districtString !== null && districtString !== undefined) {
            districtSelected = parseInt(districtString)
          }
          address = data.receiverStreet
        } else if (countryAreaSelected === '香港') {
          countySelected = data.receiverCountyHK
          address = data.receiverGlobal2
        } else if (countryAreaSelected === '澳門') {
          countySelected = data.receiverCountyMC
          address = data.receiverGlobal2
        } else if (countryAreaSelected === '中國') {
          stateProvinceCity = data.receiverGlobal1
          address = data.receiverGlobal2
          company = data.receiverCompany
        } else if (countryAreaSelected === '新加坡') {
          stateProvinceCity = data.receiverGlobal1
          address = data.receiverGlobal2
        } else {
          countryAreaSelected = null
        }

        const shippingInfo = {
          name: shippingInfoName,
          phoneArea: shippingInfoPhoneArea,
          phoneNumber: shippingInfoPhoneNumber,
          address,
          stateProvinceCity,
          company
        }

        const receiptNumber = data.receiptNum
        const paymentType = data.paymentType

        return {
          countryAreaSelected,
          countySelected,
          districtSelected,
          orderInfo,
          shippingInfo,
          receiptNumber,
          paymentType
        }
      }
    },
    assignUserInfoFromData (data: UserInfo) {
      if (data) {
        this.countryAreaSelected = data.countryAreaSelected
        this.countySelected = data.countySelected
        this.districtSelected = data.districtSelected
        this.orderInfo = Object.assign({}, data.orderInfo)
        this.shippingInfo = Object.assign({}, data.shippingInfo)
        this.receiptNumber = data.receiptNumber
        if (data.paymentType.toString() === '0') {
          this.paymentMethod = 'card'
        } else if (data.paymentType.toString() === '1') {
          this.paymentMethod = 'transfer'
        } else if (data.paymentType.toString() === '2') {
          this.paymentMethod = 'famiPort'
        } else {
          this.paymentMethod = 'card'
        }
      }
    },
    isDefaultUserInfo (data: UserInfo) {
      return data.countryAreaSelected === null &&
      data.countySelected === null &&
      data.districtSelected === null &&
      data.orderInfo.email.length === 0 &&
      data.orderInfo.name.length === 0 &&
      data.orderInfo.phoneArea === null &&
      data.orderInfo.phoneNumber.length === 0 &&
      data.shippingInfo.address.length === 0 &&
      data.shippingInfo.name.length === 0 &&
      data.shippingInfo.phoneArea === null &&
      data.shippingInfo.phoneNumber.length === 0 &&
      data.shippingInfo.company.length === 0
    },
    clearOrderInfo () {
      this.$bvModal.msgBoxConfirm('確定清除訂購人資訊？', {
        centered: true,
        noCloseOnBackdrop: true,
        noCloseOnEsc: true,
        footerClass: 'msgbox-confirm-footer',
        cancelTitle: '取消',
        okTitle: '確定'
      }).then((result) => {
        if (result) {
          this.orderInfo = {
            name: '',
            phoneArea: null,
            phoneNumber: '',
            email: ''
          }
          this.saveUserInfoToLocalStorage()
        }
      })
    },
    clearShippingInfo () {
      this.$bvModal.msgBoxConfirm('確定清除收件人資訊？', {
        centered: true,
        noCloseOnBackdrop: true,
        noCloseOnEsc: true,
        footerClass: 'msgbox-confirm-footer',
        cancelTitle: '取消',
        okTitle: '確定'
      }).then((result) => {
        if (result) {
          this.shippingInfo = {
            name: '',
            phoneArea: null,
            phoneNumber: '',
            address: '',
            company: '',
            stateProvinceCity: ''
          }
          this.countryAreaSelected = null
          this.countySelected = null
          this.districtSelected = null
          this.onCountryAreaChanged()
          this.saveUserInfoToLocalStorage()
        }
      })
    },
    gernerateOrderId () {
      let randomStr = ''
      for (let i = 0; i < 5; i++) {
        randomStr += Math.floor(Math.random() * 10)
      }
      var formattedDate = moment().format('YYMMDDHHmmssSSS')
      const orederId = `${formattedDate}${randomStr}`
      console.log(orederId)
      return orederId.length === 20 ? orederId : undefined
    },
    getFullAddress () {
      let address
      if (this.countryAreaSelected === '台灣' && this.countySelected !== null && this.districtSelected !== null) {
        const countyIndex = parseInt(this.countySelected.toString())
        const districtIndex = parseInt(this.districtSelected.toString())
        const postalCode = DistrictInfo.district_types[countyIndex][districtIndex].code
        const county = DistrictInfo.county_types[countyIndex].text
        const district = DistrictInfo.district_types[countyIndex][districtIndex].text
        address = `${postalCode} ${county}${district}${this.shippingInfo.address}`
      } else if (this.countryAreaSelected === '香港' && this.countySelected !== null) {
        const county = this.countySelected
        address = `(Hong Kong)${county}${this.shippingInfo.address}`
      } else if (this.countryAreaSelected === '澳門' && this.countySelected !== null) {
        const county = this.countySelected
        address = `(Macau)${county}${this.shippingInfo.address}`
      } else if (this.countryAreaSelected === '中國') {
        address = `(China)${this.shippingInfo.address}`
      } else if (this.countryAreaSelected === '新加坡') {
        address = `(Singapore)${this.shippingInfo.address}`
      }
      return address
    },
    async handleSetOrderInfo (orderId: string) {
      if (this.orderInfo.phoneArea === null || this.shippingInfo.phoneArea === null) throw new Error('請確認訂購人及收件人的電話是否正確')
      if (this.countryAreaSelected === null) throw new Error('請選擇收件人國家')

      this.isLoading = true
      // Set token
      let token = this.$store.getters.token
      if (this.$route.query.webview === '1') {
        token = this.$route.query.token || this.$store.getters.token
      }

      // Set tx_status
      let txStatus = 0; let txType = 0
      const finalAmount = this.getFinalAmount
      if (this.paymentMethod === 'card') {
        txStatus = 0
        if (this.checkoutConfig.cathay_credit_comp1 === 0) {
          txType = 3
        } else if (this.checkoutConfig.cathay_credit_comp1 > 0) {
          txType = this.checkoutConfig.cathay_credit_comp1 + 1
        }
      } else if (this.paymentMethod === 'transfer') {
        txStatus = 3
        txType = 1
      } else if (this.paymentMethod === 'famiPort') {
        txStatus = 3
        txType = 7
      }
      /*
      if (finalAmount < 3) {
        txStatus = 8
      }
      */

      // Set amount message
      let amountMessage = this.$store.getters.checkoutItemsString
      if (this.paymentMethod === 'famiPort') {
        if (this.checkoutConfig.no_famiport_pay_fee_off === 1) {
          amountMessage += ` + 全家付款手續費 ${this.handlingFee} 元（消費若滿 %d 元 即享免手續費）`
        } else {
          amountMessage += ` + 全家付款手續費 ${this.handlingFee} 元`
        }
      }
      if (this.couponUsed > 0) {
        amountMessage += ` - 優惠 ${this.couponUsed} 元`
      }
      amountMessage += ` + 物流 ${this.getShippingFee} 元`
      if (this.coinDiscount > 0) {
        amountMessage += ` - 會員點數 ${this.coinDiscount} 元`
      }
      if (this.nuCoinDiscount > 0) {
        amountMessage += ` - nu幣折抵 ${this.nuCoinDiscount} 元`
      }
      amountMessage += ` = 共 ${this.getFinalAmount} 元`
      /*
      if (finalAmount < 3) {
        amountMessage += ` 餘額 ${finalAmount} 元贈送，可直接結帳`
      } else {
        amountMessage += ` = 共 ${this.getFinalAmount} 元`
      }
      */

      let amount = finalAmount
      // let amount = finalAmount < 3 ? 0 : finalAmount
      if (this.addValueMode) {
        amountMessage += `  會員儲值 ${this.addValueCost} 元，折抵後獲得點數 ${this.coinAdd} 點`
        amount = this.addValueCost
      }

      const imagePath = generateImagePath(this.$store.getters['webview/platform'])
      this.$store.commit('logger/SET_IMAGE_PATH', imagePath)

      try {
        const requestBody = {
          token,
          order_id: orderId,
          app_index: process.env.VUE_APP_INDEX,
          uname: this.orderInfo.name,
          utel: this.transformPhoneNumberByArea(this.orderInfo.phoneArea, this.orderInfo.phoneNumber),
          umail: this.orderInfo.email,
          rec_name: this.shippingInfo.name,
          rec_address: this.getFullAddress(),
          rec_phone: this.transformPhoneNumberByArea(this.shippingInfo.phoneArea, this.shippingInfo.phoneNumber),
          rec_country: countryISOCode[this.countryAreaSelected],
          rec_company: this.countryAreaSelected === '中國' ? this.shippingInfo.company : '',
          tel_country: this.userCountryISOCode,
          image_path: imagePath,
          tx_status: txStatus,
          tx_type: txType,
          amount: amount,
          ver_no: this.$store.getters['webview/ver_no'],
          device: this.$store.getters['webview/device'],
          os_ver: this.$store.getters['webview/os_ver'],
          style_ver: 15,
          amount_msg: amountMessage,
          receipt_no: this.receiptType === 'company' ? this.receiptNumber : '',
          cpid: this.staticCouponCode,
          coin_used: this.coinUse ? this.coinUsedAmount.toString() : '',
          coin_add: this.coinAdd,
          bank_name: this.$store.getters['webview/bank_name'],
          upload_image_server: this.$store.getters['webview/upload_image_server'] || this.checkoutConfig.upload_image_server,
          cal1_cost: this.$store.getters['webview/cal1_cost'],
          nucoin_used: this.nuCoinUse ? this.nuCoinUsedAmount : '',
          nucoin_add: this.nuCoinObtain
        } as IOrderRequest
        this.$store.commit('logger/PUSH_LOG', { setOrderInfoRequest: requestBody })

        const { data } = await setOrderInfo(requestBody)
        if (data.flag === 0) {
          console.log('Checkout success')

          if (finalAmount === 0) {
            this.onCheckoutFinished(orderId, data.msg, token)
            return
          }

          if (this.paymentMethod === 'card') {
            this.$router.push({ name: 'Payment', params: { orderId }, query: this.$route.query })
          } else if (this.paymentMethod === 'transfer') {
            this.onCheckoutFinished(orderId, data.msg, token)
          } else if (this.paymentMethod === 'famiPort') {
            this.onCheckoutFinished(orderId, data.msg, token)
          }
          this.$store.commit('SET_ORDER_INFO', null)
        } else {
          this.$store.commit('logger/PUSH_LOG', data.msg)
          this.getCheckoutCartList()
          this.$bvModal.msgBoxOk(data.msg, {
            centered: true,
            noCloseOnBackdrop: true,
            noCloseOnEsc: true,
            footerClass: 'msgbox-ok-footer',
            okTitle: '確定'
          })
        }
      } catch (error) {
        this.$store.commit('logger/PUSH_LOG', error)
        this.getCheckoutCartList()
        this.$bvModal.msgBoxOk(`上傳訂單時發生錯誤，請檢查您的欄位是否正確或是網路狀態良好，若有問題請聯絡客服。錯誤：${error.message}`, {
          centered: true,
          noCloseOnBackdrop: true,
          noCloseOnEsc: true,
          footerClass: 'msgbox-ok-footer',
          okTitle: '確定'
        })
      } finally {
        this.isLoading = false
        this.isCheckoutProcessing = false
      }
    },
    /*
    ** Send tracing data, show modal and upload log
    */
    onCheckoutFinished (orderId: string, showMessage: string, token: string) {
      this.sendTracingData(orderId)
      this.showTransferSerialOrFamiPortCodeModal(showMessage)
      this.$store.dispatch('logger/PUSH_LOG', 'onCheckoutFinished')
      this.$store.dispatch('logger/UPLOAD_LOG', { token, isOrderUpload: true })
    },
    showTransferSerialOrFamiPortCodeModal (message: string) {
      this.clearCheckoutConfig()
      const h = this.$createElement
      const messagesList = message.split(/\\n/)
      const messageVNode = [] as VNode[]
      messagesList.forEach(text => {
        messageVNode.push(h('p', text))
      })

      this.$bvModal.msgBoxOk(messageVNode, {
        centered: true,
        noCloseOnBackdrop: true,
        noCloseOnEsc: true,
        footerClass: 'msgbox-ok-footer',
        okTitle: '確定'
      }).then(() => {
        this.$store.commit('SET_CART_LIST', null)

        if (this.$store.getters.isWebViewMode) {
          postAppMessage(MessageHandlers.ON_TRANSACTION_SUCCESS, true)
          this.$router.replace({ name: 'Cart', query: this.$route.query })
        } else {
          this.$router.replace({ name: 'Order' })
        }
      })
    },
    transformPhoneNumberByArea (phoneNumberCode: string, phoneNumber: string) {
      if (phoneNumberCode === '+886') {
        phoneNumber = phoneNumber.replace(/^\+?886/, '')
        if (phoneNumber.charAt(0) === '9') {
          phoneNumber = phoneNumber.padStart(10, '0')
          console.log(phoneNumber)
        }
        return phoneNumber
      } else {
        return phoneNumberCode.concat(phoneNumber)
      }
    },
    async handleAddToCart (item: IVariant) {
      this.isLoading = true
      this.updateCartApiQueueCount += 1
      try {
        const token = this.$store.getters.isWebViewMode ? this.$route.query.token || this.$store.getters.token : this.$store.getters.token
        const requestBody = {
          token,
          variant_id: item.variant_id,
          qty: 1,
          return_cart: 1,
          title: item.title
        } as IAddToCartAction

        const response = await this.$store.dispatch('ADD_TO_CART', requestBody)
        this.isLoading = false
        if (response.flag === 0) {
          postAppMessage(MessageHandlers.UPDATE_CART_BADGE, response.data.count)
          await this.handleUseCouponCode(false)
          this.popToast()
        } else if (response.flag === 2) {
          this.$bvModal.msgBoxOk('您已在其他地方登入，請重新登入。', {
            centered: true,
            footerClass: 'msgbox-ok-footer',
            okTitle: '確定'
          }).then(() => {
            if (this.$route.query.webview !== '1') {
              this.$router.push({ name: 'Login', query: { redirect: this.$route.path } })
            }
          })
        }
      } catch (error) {
        this.isLoading = false
        console.error(error)
        this.$bvModal.msgBoxOk(`載入資料失敗，${error.message}`, {
          centered: true,
          footerClass: 'msgbox-ok-footer',
          okTitle: '確定'
        })
      } finally {
        this.updateCartApiQueueCount -= 1
        this.calculateCoinUsed()
      }
    },
    popToast () {
      this.isShowToast = true
      setTimeout(() => { this.isShowToast = false }, 2000)
    },
    async handleUpdateCart (item: ICartItem, deleted = false) {
      this.isLoading = true
      const updateStr = `${item.id}:${item.qty}:${item.checked}:${~~deleted}`
      if (deleted) {
        this.updateCartApiQueueCount += 1
      }

      const token = this.$store.getters.isWebViewMode ? this.$route.query.token || this.$store.getters.token : this.$store.getters.token
      const requestBody = {
        token,
        update_list: updateStr,
        return_cart: ~~deleted
      } as IUpdateCartRequest

      try {
        const response = await this.$store.dispatch('UPDATE_CART', { deleted, data: requestBody })
        this.isLoading = false
        if (response.flag === 0 || response.flag === 1) {
          postAppMessage(MessageHandlers.UPDATE_CART_BADGE, response.data.count)
          await this.handleUseCouponCode(false)
          console.log('購物車已更新')
        } else if (response.flag === 2) {
          this.$bvModal.msgBoxOk('您已在其他地方登入，請重新登入。', {
            centered: true,
            footerClass: 'msgbox-ok-footer',
            okTitle: '確定'
          }).then(() => {
            if (this.$route.query.webview !== '1') {
              this.$router.push({ name: 'Login', query: { redirect: this.$route.path } })
            }
          })
        }
      } catch (error) {
        console.error(error)
        this.$store.commit('logger/PUSH_LOG', error)
        this.getCheckoutCartList()
        this.$bvModal.msgBoxOk(`更新購物車時發生錯誤，${error}`, {
          centered: true,
          footerClass: 'msgbox-ok-footer',
          okTitle: '確定'
        })
      } finally {
        this.updateCartApiQueueCount -= 1
        this.calculateCoinUsed()
      }
    },
    onQuanitySelectorStateChanged (state: string) {
      if (state === 'throttling') {
        this.updateCartApiQueueCount += 1
      }
    },
    noMesh (tmpItem: ICartItem): boolean {
      return checkNoMeshInProduct(tmpItem.product_id, tmpItem.title)
    },
    noMeshById (tmpItem: ICartItem): boolean {
      return checkNoMeshById(tmpItem.product_id)
    },
    showHkDeliveryMessage () {
      const h = this.$createElement
      const messageVNode = h('div', { class: ['foobar'] }, [
        h('p', {
          domProps: {
            style: 'display: flex; flex-direction: column;'
          }
        }, [
          h('span', ' 因應香港疫情擴大，順豐無法到府配送只能自取。請提供站所自取或是貨物智能櫃自取的收件地址。'),
          h('a', {
            domProps: {
              href: 'https://www.sf-express.com/hk/tc/dynamic_function/S.F.Network/SF_store_address/',
              style: 'padding-top: 10px'
            }
          }, '點此到順豐站所網頁'),
          h('a', {
            domProps: {
              href: 'https://www.sf-express.com/hk/tc/dynamic_function/S.F.Network/EF-Locker/',
              style: 'padding-top: 10px'
            }
          }, '點此到貨物智能櫃網頁')
        ])
      ])
      this.$bvModal.msgBoxOk([messageVNode], {
        centered: true,
        footerClass: 'msgbox-ok-footer',
        okTitle: '確定'
      })
    },
    async handleNuCoinObtain (watchTime: number) {
      this.isLoading = true
      try {
        const response = await getNuCoinInfo({
          amount: this.getFinalAmount
        })

        if (response) {
          this.isLoading = false
          if (watchTime >= this.watchTime) {
            this.nuCoinObtain = response.data.nucoin
          }
          return Promise.resolve(true)
        } else {
          this.isLoading = false
          this.nuCoinObtain = 0

          return Promise.resolve(false)
        }
      } catch (error) {
        this.isLoading = false
        this.$bvModal.msgBoxOk('發生錯誤，請重新整理頁面後再試。', {
          centered: true,
          footerClass: 'msgbox-ok-footer',
          okTitle: '確定'
        })
        return Promise.reject(error)
      }
    },
    onPaymentMethodClicked (payment: string) {
      if (this.addValueMode && this.isAddValueCardOnly && payment !== 'card') {
        this.$bvModal.msgBoxOk('優惠儲值方案僅能使用信用卡付款。', {
          centered: true,
          footerClass: 'msgbox-ok-footer',
          okTitle: '確定'
        })
      }

      if ((this.addValueMode && !this.isAddValueCardOnly && payment === 'famiPort' && this.addValueOptionShow[this.addValueSelected].value > 20000) || (
        !this.addValueMode && payment === 'famiPort' && this.getFinalAmount > 20000)) {
        this.paymentMethod = 'card'
        this.saveUserInfoToLocalStorage()
        this.$bvModal.msgBoxOk('全家代碼繳費上限為20000元，已自動更改為信用卡付款。', {
          centered: true,
          footerClass: 'msgbox-ok-footer',
          okTitle: '確定'
        })
      }
    }
  }
})
